import { Box } from "@mui/material";
import CustomButton from "../../../UIElements/CustomButton";
import { useRef } from "react";

type CgvModalContentProps = {
    acceptCgv: Function;
    rejectCgv: Function;
};

export default function CgvModalContent({
    acceptCgv,
    rejectCgv,
}: CgvModalContentProps) {
    const iframeRef = useRef(null);

    return (
        <>
            {/* <embed src="/cgv.pdf" /> */}

            <iframe
                ref={iframeRef}
                title="PDF Viewer"
                allow="fullscreen"
                src="/pdf/cgv.pdf"
                loading="lazy"
                width="100%"
                height="460rem"
                style={{ border: "none" }}
            />

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    alignSelf: "stretch",
                }}
            >
                <CustomButton
                    onClick={() => {
                        acceptCgv();
                    }}
                    label="Accepter"
                />
                <CustomButton
                    onClick={() => {
                        rejectCgv();
                    }}
                    label="Refuser"
                    customsx={{
                        background: "#F43B00",
                    }}
                />
            </Box>
        </>
    );
}
